module.exports = __webpack_public_path__ + "media/images/logo-5ec1ce671fdeff4ea439d58ea825db50.svg";